<template>
  <owa-message
    v-if="shouldShow"
    :title="title"
    :content="content"
    :icon-style="iconStyle"
    :icon-name="iconName"
    :theme="theme"
    has-border
    type="flash"
    @action="clear"
  />
</template>

<script>
  import get from 'lodash/get'
  import { mapGetters, mapActions } from 'vuex'

  export default {
    name: 'FlashMessage',

    props: {
      topic: {
        type: String,
        default: 'general'
      }
    },

    computed: {
      ...mapGetters('flashMessages', ['getMessage']),

      message() {
        return this.getMessage(this.topic)
      },

      shouldShow() {
        return this.message !== null
      },

      title() {
        return get(this, ['message', 'title'], null)
      },

      content() {
        return get(this, ['message', 'content'], 'That thing you just did? Yeah…It worked perfectly good and fine because you are just that fine and good.')
      },

      iconStyle() {
        return get(this, ['message', 'iconStyle'], 'solid')
      },

      iconName() {
        return get(this, ['message', 'iconName'], 'faCircleInfo')
      },

      theme() {
        return get(this, ['message', 'theme'], 'info')
      }
    },

    methods: {
      ...mapActions('flashMessages', ['clearFlashMessage', 'clearFlashMessages']),

      clear() {
        this.clearFlashMessage({ topic: this.topic })
      }
    }
  }
</script>
